module.exports = __webpack_public_path__ + "img/check.5b908fc6.svg";